import React, { useState, useEffect, useContext, useRef } from "react";
import { DataGrid } from "@mui/x-data-grid";
import {
  Container,
  Card,
  CardContent,
  Grid,
  Typography,
  Divider,
  TextField,
  Button,
  makeStyles,
} from "@material-ui/core";
import styled from "styled-components";
import Box from "@mui/material/Box"
import { convertFromRaw, convertToRaw, EditorState } from 'draft-js';

import { Link, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { useQuery, useManualQuery, useMutation, ClientContext } from "graphql-hooks";

import Header from "../components/Header.js";
import TextEditor from "./rteTestEditor.js";
import draftToHtml from "draftjs-to-html";
import ReactHtmlParser from "react-html-parser";
import { project_url } from "../constants/Data";

const useStyles = makeStyles((theme) => ({
  root: {
    marginLeft: "8rem",
    marginRight: "8rem",
    marginTop: "2rem",
    textAlign: "center",
    padding: theme.spacing(2),
    minWidth: "500px",
  },
  container: {
    padding: theme.spacing(4),
    marginTop: "2rem",
    marginBottom: "5rem",
    overflow: "hidden",
    clear: "both",
  //  minWidth: "1000px",
    //height: "600px",
    borderRadius: "8px",
    backgroundColor: "#ffffff",
  },
  buttonStyle: {
    borderRadius: 4,
    width: "100px",
    padding: 0,
    color: "#fff",
    height: "34px",
    backgroundColor: "#0D47A1",
    textTransform: "none",
    // "&:active": {
    //   backgroundColor: "#765285",
    // },
    "&:hover": {
      backgroundColor: "#1E88E5",
    },
  },
}));

const SAVE_TEST_RTE = `
    mutation saveTestRte($text: String!) {
      saveTestRte(text: $text) {
        text
      }
    }
`;

const FETCH_TEST_RTE_QUERY = `query fetchTestRte($text: String!) {fetchTestRte(text: $text)
}`;

function RTETest() {
  const classes = useStyles();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const form = useRef(null);
  const navigate = useNavigate();
  const [queRaw, setQueRaw] = useState();
  const [queRawEdit, setQueRawEdit] = useState();
  const [saveTestRTE] = useMutation(SAVE_TEST_RTE);
  const {
    loading: loadingTextForm,
    error: errorTextForm,
    data: dataTextForm,
  } = useQuery(FETCH_TEST_RTE_QUERY, {
    variables: {
      text: "",
    },
  });
  
  useEffect(() => {
    if (
      !loadingTextForm &&
      dataTextForm &&
      dataTextForm.fetchTestRte
    ) {
      //setQueRaw(JSON.parse(dataTextForm.fetchTestRte.replace(/'/g, '"')));
      //commented by sami at 30August 2025
      setQueRaw(JSON.parse(dataTextForm.fetchTestRte));
    }
    else if (errorTextForm)
        console.log("Error", errorTextForm, dataTextForm);
  }, [dataTextForm]);

  const formatter = new Intl.DateTimeFormat('en-us', {
    
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',    

  });
  
  const handleChangeTextEditor = (txt) => {
    let contentHTML = draftToHtml(txt);
    contentHTML = contentHTML.replace(/<p>/, "");
    const convertedTxt = ReactHtmlParser(contentHTML);
    setQueRawEdit(txt);
  };

  function DataGridTitle() {
    return (
      <>
        <Grid
          container
          xs={12}
          style={{
            paddingTop: 5,
            paddingBottom: 6,
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Grid item xs={10} style={{ textAlign: "center" }}>
            <Typography variant="h1" style={{ fontSize: 20, paddingLeft: 100 }}>
              Text Editor Test
            </Typography>
          </Grid>
        </Grid>
        <Divider />
      </>
    );
  }
  
   /*
   * Function : onSubmit
   * Description : Submit form data
   */
  const onSubmit = async formData => {
      const { data, error } = await saveTestRTE({
        variables: {
          text: JSON.stringify(queRawEdit),
        }
      });
      if (error) {
        console.log("Error", error, data);
        alert("Unfortunately an error occurred.");
      } else if (data && data.saveTestRte) {
        alert("Text is successfully pickled and saved as " + data.saveTestRte.text);
        console.log("Success", data);
        window.location = `${project_url}/tests/rte/`;
      }
  };
  
  return (
    <div className={classes.root} style={{ textAlign: 'left' }}>
      <Header />
      <div className={classes.container}>
        <Grid item lg={6} xl={6} md={4}>
          <Box mt={2} ml={2} mb={2} mr={2}>
           <form ref={form} onSubmit={handleSubmit(onSubmit)}>
            <TextEditor
              value={queRaw}
              name="text"
              id="text"
              handleChangeText={(txt) =>
                handleChangeTextEditor(txt)
              }
            />
            <Button
              variant="contained"
              color="primary"
              className={classes.buttonStyle}
              style={{ marginRight: 2 }}
              type="submit"
            >
              Save
            </Button>
           </form>
          </Box>
        </Grid>
      </div>
    </div>
  );
}

export default RTETest;
